import { render } from "./MenuDeroulant.vue?vue&type=template&id=5f11ef9a&scoped=true"
import script from "./MenuDeroulant.vue?vue&type=script&lang=js"
export * from "./MenuDeroulant.vue?vue&type=script&lang=js"

import "./MenuDeroulant.vue?vue&type=style&index=0&id=5f11ef9a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hechque\\WebstormProjects\\2022-PO-MSC-CSS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f11ef9a"]])

export default __exports__